export default (paxCode) => {
    if(paxCode === "ADT") return "Adult"
    else if(paxCode === "CNN") return "Child"
    else if(paxCode === "INF") return "Infant"
    return ""
}